import { useState } from 'react';
import { supabase } from '../../../utils/supabase';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Por favor, introduce un email válido.');
      return;
    }

    setStatus('loading');

    try {
      const { error } = await supabase
        .from('newsletter_subscribers')
        .insert([
          { 
            email: email.toLowerCase().trim(),
            source: 'website'
          }
        ]);

      if (error) {
        if (error.code === '23505') {
          setStatus('error');
          setMessage('Este email ya está suscrito ✨');
        } else {
          setStatus('error');
          setMessage('Algo salió mal. Inténtalo de nuevo.');
        }
      } else {
        setStatus('success');
        setMessage('¡Listo! Ya estás en la lista ✨');
        setEmail('');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Error al enviar. Inténtalo de nuevo.');
    }
  };

  return (
    <section className="relative bg-white py-16 lg:py-20 px-8 md:px-12 lg:px-[8%] overflow-hidden">
      <div className="max-w-xl lg:ml-[5%] relative z-10">
        <h2 className="text-[clamp(1.8rem,3.5vw,2.6rem)] font-bold text-[#222222] leading-tight tracking-[-0.01em] mb-3">
          Te aviso cuando encuentro algo bueno ✨
        </h2>
        <p className="text-[16px] lg:text-[17px] text-[#6B6860] font-light mb-6">
          Máximo 1 email por semana. Cero spam. Te puedes dar de baja cuando quieras.
        </p>

        <form onSubmit={handleSubmit} className="mb-4">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              className="flex-1 px-5 py-3.5 border border-[#E8DED2] rounded-md text-[15px] text-[#222222] placeholder-[#A39B92] focus:outline-none focus:border-[#EBCFD4] transition-colors"
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3.5 bg-[#EBCFD4] text-[#222222] text-[14px] font-medium rounded-md hover:bg-[#E0BFC4] hover:-translate-y-0.5 hover:shadow-sm transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'loading' ? 'Enviando...' : 'Apuntarme'}
            </button>
          </div>
        </form>

        {status === 'success' && (
          <p className="text-[14px] text-[#EBCFD4] font-medium">{message}</p>
        )}
        {status === 'error' && (
          <p className="text-[14px] text-[#D4A5A5] font-medium">{message}</p>
        )}
      </div>
    </section>
  );
}
